import { render, staticRenderFns } from "./IndicatorWithSubtitleH2.vue?vue&type=template&id=d45095b0"
import script from "./IndicatorWithSubtitleH2.vue?vue&type=script&lang=js"
export * from "./IndicatorWithSubtitleH2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports